import { debounce } from '@utils/helper.js';

let distanceScrolled = -1;
let distanceThreshold = [
    { threshold: 0, value: 'Baseline', sent: false },
    { threshold: 25, value: '25%', sent: false },
    { threshold: 50, value: '50%', sent: false },
    { threshold: 75, value: '75%', sent: false },
    { threshold: 100, value: '100%', sent: false },
];

const scrollDepth = () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    let progress = Math.round(
        (scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100
    );

    if (isNaN(progress)) progress = 0;

    if (progress > distanceScrolled) {
        distanceScrolled = progress;

        for (const item of distanceThreshold) {
            const status = item.sent;
            const threshold = item.threshold;
            const value = item.value;

            if (!status && progress >= threshold && 'dataLayer' in window) {
                window.dataLayer.push({
                    event: 'gatsbyScroll',
                    gatsbyScrollDistance: value,
                });
                item.sent = true;
            }
        }
    }
};

const scrollDelay = 18;
const scrollListener = debounce('scrollDepth', scrollDepth, scrollDelay);

const GTM = {
    init: () => {
        const interval = setInterval(() => {
            if ('dataLayer' in window && 'google_tag_manager' in window) {
                window.dataLayer.push({ event: 'gatsby-route-change' });
                clearInterval(interval);
            }
        }, 100);
        scrollDepth();
        document.addEventListener('scroll', scrollListener);
    },
    // Expand/Collapse START
    toggleMobileMenu: isExpanded => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'toggleMobileMenu',
                mobileMenuState: isExpanded ? 'Expand' : 'Collapse',
            });
        }
    },
    toggleAccordion: isExpanded => {
        window.dataLayer.push({
            event: 'toggleAccordion',
            accordionState: isExpanded ? 'Collapse' : 'Expand',
        });
    },
    // Expand/Collapse END

    // form tags START
    formSubmission: () => {
        if ('dataLayer' in window) {
            window.dataLayer.push({ event: 'formCompletion' });
        }
    },
    formInputChange: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'inputChange',
                fieldName: field,
                fieldValue: value,
            });
        }
    },
    formInputError: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'formInputError',
                fieldName: field,
                fieldError: value,
            });
        }
    },
    formFieldCompletionFormSubmitted: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'formFieldCompletionFormSubmitted',
                fieldName: field,
                fieldValue: value,
            });
        }
    },
    // form tags END
    // formulary tool tags START
    // 4.4
    // Track Formulary Coverage Tool interactions.

    // Event Name – formulary_tool
    // Event parameter – Event_Action – $ClickText
    // Event parameter – Event_Label – $FieldValue
    // $ClickText = {Indication|Location|NPI|Search|Show All|Commercial|Medicaid|Medicare|Show Details}
    // Where $FieldValue is the field that users clicked. For example, Schizophrenia, Bipolar Depression, Alabama, Alaska, etc. For “Search|Show All|Commercial|Medicaid|Medicare” button click, the event_label should be ‘Click’.
    // Do not collect any PII information. Do not capture NPI values.

    formularyToolChange: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'formularyToolChange',
                fieldName: field,
                fieldValue: value,
            });
        }
    },

    //     4.5
    // Track Formulary Coverage Tool interactions. This should capture all the responses after the user clicks on ‘Search’ to return the results.

    // Event Name – formulary_tool_search
    // Event parameter – Event_Action – $FieldName
    // Event parameter – Event_Label – $FieldValue
    // $FieldName = {Indication|Location|NPI}
    // Where $FieldValue is the field that users clicked. For example, Schizophrenia, Bipolar Depression, Alabama, Alaska, etc
    // Do not collect any PII information. Do not capture NPI values.
    formularyToolCompletionSearchSubmitted: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'formularyToolCompletionSearchSubmitted',
                fieldName: field,
                fieldValue: value,
            });
        }
    },
    //     4.6
    // Track Formulary Coverage Tool search error. This should capture all the error messages after the user clicks on ‘Search’ but failed to return the results.
    // Event Name – formulary_tool_error
    // Event parameter – Event_Action – $FieldName
    // Event parameter – Event_Label – $ErrorMessage
    // $FieldName = {Indication|Location|NPI}
    // $ErrorMessage example: “Please enter a valid ZIP code or state”
    // Do not collect any PII information. Do not capture NPI values.
    formularyToolError: (field, value) => {
        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'formularyToolError',
                fieldName: field,
                fieldError: value,
            });
        }
    },
    // formulary tool tags END
    reset: () => {
        distanceScrolled = -1;
        distanceThreshold.forEach(threshold => (threshold.sent = false));
    },
};

export default GTM;
